import React, { useEffect, useRef, useState } from "react";
import { LogIn, User as UserIcon, LayoutDashboard, LogOut } from "lucide-react";
import { colors } from "../theme";
import { useAuth } from "../store/useAuth";

export default function AuthWidget() {
  const { user, loading, openModal, openProfile, openAdmin, logout } = useAuth();
  const [menu, setMenu] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setMenu(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  if (loading) return null;

  if (!user) {
    return (
      <button style={s.signIn} onClick={() => openModal("signup")} data-testid="signin-btn" title="Sign in to save & sync">
        <LogIn size={15} strokeWidth={2.3} /> Sign in
      </button>
    );
  }

  const initials = (user.name || user.email || "?").trim().slice(0, 1).toUpperCase();
  return (
    <div style={s.wrap} ref={ref}>
      <button style={s.avatar} onClick={() => setMenu((v) => !v)} data-testid="account-avatar" title={user.email}>
        {user.picture ? <img src={user.picture} alt="" style={s.avatarImg} /> : <span>{initials}</span>}
      </button>
      {menu && (
        <div style={s.menu} data-testid="account-menu">
          <div style={s.menuHead}>
            <div style={s.menuName}>{user.name || "Account"}</div>
            <div style={s.menuEmail}>{user.email}</div>
            {user.is_admin && <span style={s.adminTag}>ADMIN</span>}
          </div>
          <button style={s.item} onClick={() => { setMenu(false); openProfile(); }} data-testid="menu-profile"><UserIcon size={15} /> Profile & activity</button>
          {user.is_admin && (
            <button style={s.item} onClick={() => { setMenu(false); openAdmin(); }} data-testid="menu-admin"><LayoutDashboard size={15} /> Admin dashboard</button>
          )}
          <button style={{ ...s.item, color: "#c0392b" }} onClick={() => { setMenu(false); logout(); }} data-testid="menu-logout"><LogOut size={15} /> Sign out</button>
        </div>
      )}
    </div>
  );
}

const s = {
  wrap: { position: "relative" },
  signIn: { display: "flex", alignItems: "center", gap: 7, padding: "8px 15px", borderRadius: 999, border: "none", background: "rgba(255,255,255,0.9)", backdropFilter: "blur(20px)", WebkitBackdropFilter: "blur(20px)", boxShadow: "0 4px 14px rgba(0,0,0,0.12)", fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif", fontSize: 12.5, fontWeight: 700, color: colors.brand, cursor: "pointer" },
  avatar: { width: 38, height: 38, borderRadius: 999, border: "2px solid rgba(255,255,255,0.9)", background: colors.brand, color: "#fff", fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif", fontSize: 15, fontWeight: 800, cursor: "pointer", boxShadow: "0 4px 14px rgba(0,0,0,0.18)", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" },
  avatarImg: { width: "100%", height: "100%", objectFit: "cover" },
  menu: { position: "absolute", top: 46, right: 0, width: 220, background: "#fff", borderRadius: 14, boxShadow: "0 16px 44px rgba(0,0,0,0.2)", padding: 6, fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif", zIndex: 3500 },
  menuHead: { padding: "10px 12px 12px", borderBottom: `1px solid ${colors.border}`, marginBottom: 5 },
  menuName: { fontSize: 13.5, fontWeight: 800, color: colors.textPrimary },
  menuEmail: { fontSize: 11, color: colors.textTertiary, marginTop: 1 },
  adminTag: { display: "inline-block", marginTop: 6, fontSize: 8.5, fontWeight: 800, letterSpacing: 1, background: colors.brand, color: "#fff", padding: "2px 7px", borderRadius: 6 },
  item: { display: "flex", alignItems: "center", gap: 10, width: "100%", padding: "10px 12px", border: "none", background: "transparent", borderRadius: 9, fontSize: 12.5, fontWeight: 600, color: colors.textPrimary, cursor: "pointer", textAlign: "left" },
};
